import { Button, Form, Modal, Select } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import { serviceQuestionBrandModalSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";

function ServiceQuestionBrandModal({ caption }: { caption?: any }) {
    const serviceId = useSelector((state: any) => state.serviceQuestionBrandModal.serviceId);
    const brandId = useSelector((state: any) => state.serviceQuestionBrandModal.brandId);
    const currentQuestions = useSelector((state: any) => state.pickAFile.questions);
    const currentServiceQuestions = useSelector((state: any) => state.pickAFile.serviceQuestions);
    const currentServiceQuestionBrand = useSelector((state: any) => state.pickAFile.serviceBrandQuestions);
    const currentServiceBrandQuestions = currentServiceQuestionBrand.filter(sb => sb.assistanceServiceId === serviceId && sb.brandId === brandId).map(q => q.questionId);
    const serviceQuestionBrandToAdd = useSelector((state: any) => state.serviceQuestionBrandModal.serviceQuestionBrandToAdd);

    const open = useSelector((state: any) => state.serviceQuestionBrandModal.open);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    let questionDropDownList = currentQuestions
        .filter(q => 
            !currentServiceBrandQuestions.includes(q.questionId) 
            && !currentServiceQuestions.some(sq => sq.assistanceServiceId == serviceId && sq.questionId == q.questionId))
        .map(q => { return ({ key: q.questionId, label: q.dataKey, value: q.questionId }) });

    let buttonCaption = caption;

    const onSubmit = () => {
        let listToUse = currentServiceQuestionBrand;

        serviceQuestionBrandToAdd.forEach(q => listToUse.push({assistanceServiceId: serviceId, brandId: brandId, questionId: q}));

        dispatch({ type: serviceQuestionBrandModalSliceDispatch.setOpen, payload: false });
        CreateContentsFromStates({ serviceBrandQuestions: listToUse });
    }

    const onCancel = () => {
        dispatch({ type: serviceQuestionBrandModalSliceDispatch.setOpen, payload: false });
    }

    const onQuestionDropDownListChange = (value) => {
        dispatch({ type: serviceQuestionBrandModalSliceDispatch.serviceQuestionBrandToAdd, payload: value });
    }

    return open ?
        (
            <Modal
                title="Add Question(s)"
                footer={null}
                closable={false}
                open={open}
                destroyOnHidden={true}
            >
                <Form
                    onFinish={onSubmit}
                    onFinishFailed={onCancel}
                    preserve={false}>
                    <Form.Item>
                        <label>Question(s)</label>
                        <Select
                            mode="multiple"
                            placeholder='Question(s)'
                            options={questionDropDownList}
                            onChange={onQuestionDropDownListChange}
                            id="questionId"
                        />
                    </Form.Item>
                </Form>
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button onClick={onCancel}>
                            Cancel
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit" onClick={onSubmit}>
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Modal>
        ) :
        (
            <Button
                onClick={() => {
                    dispatch({ type: serviceQuestionBrandModalSliceDispatch.setOpen, payload: true });
                    dispatch({ type: serviceQuestionBrandModalSliceDispatch.serviceQuestionBrandToAdd, payload: [] })
                }}>{buttonCaption}
            </Button>
        )
}

export default ServiceQuestionBrandModal;